import { Activity, Building, Headset, LayoutDashboard, ScrollText, ShieldCheck } from 'lucide-react';
import type { NavGroup, PaletteCommand } from './types';

/** TCM platform console: the people who run the SaaS, not the center operators. */
export const internalNav: readonly NavGroup[] = [
  {
    id: 'platform',
    label: 'Platform',
    items: [
      { id: 'overview', label: 'Overview', to: '/internal', icon: LayoutDashboard, end: true, keywords: ['dashboard', 'health', 'mrr'] },
      { id: 'organizations', label: 'Organizations', to: '/internal/organizations', icon: Building, tab: true, tabLabel: 'Orgs', keywords: ['accounts', 'customers', 'operators', 'owners', 'subscription'] },
      { id: 'analytics', label: 'Analytics', to: '/internal/analytics', icon: Activity, tab: true, keywords: ['adoption', 'churn', 'revenue', 'funnel'] },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    items: [
      { id: 'support', label: 'Support', to: '/internal/support', icon: Headset, tab: true, keywords: ['cx', 'tickets', 'help desk', 'escalations'] },
      { id: 'audit', label: 'Audit trail', to: '/internal/audit', icon: ScrollText, keywords: ['log', 'security', 'activity', 'events'] },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    items: [{ id: 'team', label: 'Team & access', to: '/internal/team', icon: ShieldCheck, keywords: ['staff', 'roles', 'permissions', 'admins'] }],
  },
];

export const internalCommands: readonly PaletteCommand[] = [];
